import { NumericFormat } from 'react-number-format';
import styled from 'styled-components';

const StyledInputNumber = styled(NumericFormat)<{ error?: boolean }>`
  width: ${props => props.width ?? 'auto'} !important;
  height: 44px;
  border-radius: 6px !important;
  font-style: ${props => (props.value ? 'normal' : 'italic')};
  font-size: 14px;
  padding: 4px 11px;
  border: 1px solid ${({ error }) => (error ? 'var(--color-10)' : '#d9d9d9')};
  outline: none;
  transition-duration: 0.25s;
  &:hover {
    border-color: ${({ error }) => (error ? 'var(--color-10)' : '#2997ff')};
  }
  &:focus {
    border-color: ${({ error }) => (error ? 'var(--color-10)' : '#2997ff')};
    box-shadow: ${({ error }) =>
      error
        ? '0 0 0 2px rgba(255,77,79,0.2)'
        : '0 0 0 2px rgba(0,122,255,0.2)'};
  }
  &::placeholder {
    color: #e0e0e0;
    opacity: 1;
  }
`;

export default StyledInputNumber;
